import React from "react";
import { WbSunny } from "@mui/icons-material";

/**
 * Get icon for circadian widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getCircadianIcon = (widget = null) => {
  const iconProps = {
    style: { fontSize: "1.5rem", paddingBottom: "2px" },
  };

  return <WbSunny {...iconProps} />;
};

/**
 * Get subtitle text for circadian widgets
 * @param {object} widget - Full widget object
 * @returns {string} Subtitle text
 */
export const getCircadianSubtitle = (widget = null) => {
  return "Circadian";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getCircadianPatterns = () => {
  return ["basic.device.circadianBrightness", "basic.device.circadianColor"];
};
